import React from "react";
import { Container, Row, Col } from "reactstrap";

const Logos = () => {
  return (
    <div className="logo-container">
      <Container fluid={true}>
        <Row>
          <Col xs="0" md="4"></Col>
          <Col xs="12" md="4">
            <img
              src="/img/logos.svg"
              className="logo-image"
              style={{ width: "100%" }}
              alt="St Jude Childrens Research Hospital logo, Oculus Logo"
            ></img>
          </Col>
          <Col xs="0" md="4"></Col>
        </Row>
      </Container>
    </div>
  );
};

export default Logos;
